import { Nav } from "react-bootstrap";

const CertificateNav = ({children, activeTab}) => {

    return (
        <Nav
            justify
            variant="tabs"
            defaultActiveKey={activeTab}
            className="col-12 my-2 border border-2 border-dark rounded-top"
        >
            {children}
        </Nav>
    );
};

export default CertificateNav;